/* en-AU locale */
export default {
  vmail: {
    forceTranscriptionEnableDialog: {
      text: 'Your message will not be summarised or transcribed',
      buttons: {
        enable: 'Enable',
        later: 'Later',
        never: 'Never'
      }
    },
    tip: {
      addToFavorites: 'Add to favourites',
      removeFromFavorites: 'Remove from favourites'
    },
    btn: {
      favourite: 'Mark as favourite',
      unfavorite: 'Unmark as favourite',
      addToFavorites: 'Add to favourites',
      removeFromFavorites: 'Remove from favourites'
    },
    cfg: {
      settings: {
        summarise: 'Enable summary',
        categorise: 'Enable category'
      }
    }
  }
}
